var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"mobile-menu"},[_c('Hamburger',{attrs:{"isActive":_vm.isMenuDisplayed},on:{"click":_vm.onBurgerClick}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }